import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { Shield, Loader2 } from 'lucide-react';

export default function AdminLogin() {
    const { adminLogin } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const u = await adminLogin(email, password);
            if (u.is_admin) {
                toast.success('Admin signed in');
                nav('/admin');
            } else {
                toast.error('Not an admin account');
            }
        } catch (e) {
            toast.error(e?.response?.data?.detail || 'Login failed');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="rrm-panel p-6">
                <Shield className="w-6 h-6 text-amber-400" />
                <h1 className="mt-2 font-display text-3xl text-white">ADMIN ACCESS</h1>
                <p className="text-white/60 text-sm mt-1">Restricted area. RRM staff only.</p>
                <form onSubmit={submit} className="mt-6 space-y-3">
                    <input type="text" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email or username" data-testid="admin-login-email" className="w-full bg-white/5 border border-white/10 rounded-md px-3 py-2 text-sm" />
                    <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="admin-login-password" className="w-full bg-white/5 border border-white/10 rounded-md px-3 py-2 text-sm" />
                    <button disabled={busy} data-testid="admin-login-submit" className="w-full px-4 py-2.5 rounded-md bg-amber-500/20 border border-amber-500/40 text-amber-200 font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-50">
                        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Shield className="w-4 h-4" />} Sign in as admin
                    </button>
                </form>
                <div className="mt-4 text-xs text-white/40">
                    Tip: you can sign in with either your admin email or your username.
                </div>
            </div>
        </div>
    );
}
